import { render, staticRenderFns } from "./lab-staff-selector.vue?vue&type=template&id=307f5c81"
import script from "./lab-staff-selector.vue?vue&type=script&lang=js"
export * from "./lab-staff-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports